
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QueryModel } from './Entities.GormCrm.Query';
import { DynamicQueryModel } from './Models.DynamicQuery';
import { Model, ModelProperty } from 'models/Model';


export class SaveQueryRequestModel extends Model<SaveQueryRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'query', type: 'QueryModel', isHidden: true, isObject: true, new: () => { return new QueryModel }, properties: () => { return QueryModel.classProperties } },
		{ name: 'queryData', type: 'DynamicQueryModel', isHidden: true, isObject: true, new: () => { return new DynamicQueryModel }, properties: () => { return DynamicQueryModel.classProperties } }
	];
	[key: string]: any;
	
	public query?: QueryModel;
	public queryData?: DynamicQueryModel;
    
	constructor(){
		super();
		this.query = undefined;
		this.queryData = undefined;
		
	}
	getProperties(){
		return SaveQueryRequestModel.classProperties;
	}
}

